import React, { useContext, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';

import AddBoxIcon from '@mui/icons-material/AddBox';

import ProjectContext from '../../contexts/ProjectContext';

import ControlButton from '../structure/ControlButton';

import ExpandedTextField from '../display/ExpandedTextField';
import ExpandedDropDown from '../dropdown/ExpandedDropDown';
import {useFetch} from '../../components/auth/useFetch';

export default function AddUserDialog(props) {
    
    const { availableRoles, open, onSuccess, setOpen, setOpenRoles } = props
    const { isAuthenticated } = useAuth0()
    const projectContext = useContext(ProjectContext)

    const fetchWithAuth = useFetch()

    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [roles, setRoles] = useState([])

    const handleClose = () => {
        setOpen(false);
    };

    const handleMultiSelectChange = (e, setState) => {
        setState(
            typeof e.target.value === 'string'
            ?
                e.target.value.split(',')
            :
                e.target.value
        )
    }

    const handleSubmit = () => {
        const body = {
            given_name: firstName,
            family_name: lastName,
            email: email,
            roles: roles,
            name: `${firstName} ${lastName}`,
            nickname: `${firstName.toLowerCase()}.${lastName.toLowerCase()}`,
        }

        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/userdetailsadmin/`, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: { 
                "Content-type": "application/json",
                'X-Project-ID': projectContext?.project_db
            }
        })
        .then(() => {
            onSuccess()
            handleClose()
        })
        .catch(e => console.error(e)) // Send a Snackbar to say unsuccessful
    }

    const validateName = (value) => {
        const nameRegex = /^[A-Za-z]+(?: [A-Za-z]+)*$/;
        return nameRegex.test(value)
    }

    const validateEmail = (value) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(value)
    }

    return (
        <Dialog
            fullWidth // Ensure the dialog takes up the full width up to the max width
            PaperProps={{
                sx: {
                    backgroundColor: 'rgb(34, 34, 34)', // Dark grey background
                    color: 'rgb(255, 255, 255)', // White text color
                    minWidth: '450px',
                },
            }}
            onClose={handleClose}
            open={open}
        >
            <DialogTitle>
                <Box
                    display='flex'
                    justifyContent='space-between'
                    alignItems='center'
                >
                    <Typography>Add A New User To {projectContext?.project_name}</Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box
                    display='flex'
                    flexDirection={{ xs: 'column', sm: 'row' }}
                >
                    <Box
                        display='flex'
                    >
                        <ExpandedTextField
                            label='First Name'
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            required
                            error={validateName(firstName) ? false : true}
                        />
                        <ExpandedTextField
                            label='Last Name'
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            required
                            error={validateName(lastName) ? false : true}
                        />
                    </Box>
                    <Box
                        display='flex'
                    >
                        <ExpandedTextField
                            label='Email'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            error={validateEmail(email) ? false : true}
                        />
                    </Box>
                    <Box
                        display='flex'
                        ml={1}
                    >
                        <ExpandedDropDown
                            label='Roles'
                            options={availableRoles}
                            onChange={(e) => handleMultiSelectChange(e, setRoles)}
                            value={roles}
                            multiple
                            fullWidth='250px'
                        />
                        {/* <ControlButton
                            clicked={() => setOpenRoles(true)}
                            title='Create New Role'
                        >
                            <AddBoxIcon style={{ fill: 'rgb(125, 125, 125)'}} />
                        </ControlButton> */}
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    sx={{ color: 'rgb(255, 255, 255)' }}
                    onClick={handleClose}
                >
                    Close
                </Button>
                <Button
                    sx={{ color: 'rgb(255, 255, 255)' }}
                    onClick={handleSubmit}
                    disabled={
                        validateName(firstName)
                        && validateName(lastName)
                        && validateEmail(email)
                        && roles.length === 1 //Remove this when Konsol can support multiple roles
                        ? false
                        : true
                    }
                >
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
}
